import { Button, Card, Space } from 'antd';
import moment from 'moment';
import React from 'react';

import type { FixRecord } from '@/types/database/fixRecord';

import ImageButton from '../../../ImageButton';

const FixRecordCard: React.FC<{
  record: FixRecord;
  onEdit: () => void;
  allowDelete: boolean;
  onDelete: () => void;
}> = ({ record, onEdit, allowDelete, onDelete }) => {
  return (
    <Card
      bordered={false}
      actions={[
        <ImageButton
          key="image"
          src={record.image?.path || ''}
          buttonProps={{
            disabled: !record.image,
            type: 'text',
          }}
        />,
        <Button key="edit" type="text" onClick={onEdit}>
          編輯
        </Button>,
        <Button
          key="delete"
          type="text"
          danger
          disabled={!allowDelete}
          onClick={onDelete}
        >
          刪除
        </Button>,
      ]}
    >
      <Space direction="vertical">
        <Space>
          <span>維修人員：</span>
          <span>{record.repairerName}</span>
        </Space>
        <Space>
          <span>維修時間：</span>
          <span>{moment(record.repairedTime).format('YY-MM-DD HH:mm')}</span>
        </Space>
        <Space>
          <span>維修紀錄：</span>
          <span>{record.content}</span>
        </Space>
        <Space>
          <span>登記人員：</span>
          <span>{record.creatorName}</span>
        </Space>
      </Space>
    </Card>
  );
};

export default FixRecordCard;
